var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../services/navigation/navigation.service';
import { PageNames } from '../page-names.enum';
import { SelectableNavigationItem } from '../../model/selectable-navigation-item';
var CtaLinkComponent = /** @class */ (function (_super) {
    __extends(CtaLinkComponent, _super);
    function CtaLinkComponent(router, navigationService, changeDetector) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.navigationService = navigationService;
        _this.changeDetector = changeDetector;
        _this.emitOnEnterPressed = new EventEmitter();
        return _this;
    }
    CtaLinkComponent.prototype.ngOnInit = function () {
        this.navigationService.registerNavigation(this, PageNames.DETAIL_PAGE_INTRO);
    };
    CtaLinkComponent.prototype.activate = function (active) {
        this.active = active;
        this.changeDetector.detectChanges();
    };
    CtaLinkComponent.prototype.onBack = function () {
        this.navigationService.resetNavigation();
        this.navigationService.clearNavigation();
        this.routeOnBackPressed();
    };
    CtaLinkComponent.prototype.routeOnBackPressed = function () {
        this.router.navigate(['/'], { queryParamsHandling: 'merge' });
    };
    CtaLinkComponent.prototype.onEnter = function () {
        this.emitOnEnterPressed.emit(this.omapiId);
    };
    CtaLinkComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    return CtaLinkComponent;
}(SelectableNavigationItem));
export { CtaLinkComponent };
